import React from 'react';
import ComponentErp from './ComponentErp.js';

import store from '../store';
import FormEdit from '../components/FormEdit.js';
import { GetServicosAPI } from '../models/ModelServicos.js';
import ServicosUpdate from './ServicosUpdate.js';


class Servicos extends ComponentErp {
  constructor(props) {
    super(props);
    this.state = store.getState().servicos.grids;
  }

  componentDidMount() {
    this.callApi()
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.refresh === 'gravando') {
      this.setState({ refresh: 'buscando' });
      this.callApi()
    }

  }


  handleSubmit = (event) => {
    event.preventDefault()

    var response = {
      refresh: 'gravando',
      fNome: this.state.fNome,
      type: 'SERVICOS.TOOGLE_FBUSCA'
    }

    this.updateReduxAndState(response);

  }


  novoCadastro = (event) => {
    event.preventDefault()
    var response = { refresh: 'limpando', id: 0, type: 'SERVICOS.TOOGLE_CLEAN' }
    this.updateReduxAndState(response);
    this.actionClick('.cadastro');
  }


  clickChildCadastro = (event, id) => {
    event.preventDefault()
    var response = '';
    if (id !== 0 && id !== store.getState().servicos.cadastro.id_servico) {

      response = {
        id: id,
        type: 'SERVICOS.TOOGLE_CADASTRO',
        refresh: 'buscaservico'
      }
      this.updateReduxAndState(response);

      this.actionClick('.cadastro');
      this.clearModal();

    } else if (id === 0) {
      response = { type: 'SERVICOS.TOOGLE_CLEAN', refresh: 'limpando' }
      this.updateReduxAndState(response);
    }

    if (this.state.aba !== 'Cadastro') {
      this.actionClick('.cadastro');
    }
    this.setAba('Cadastro');
  }

  async callApi() {
    var grids = store.getState().servicos.grids;

    var response = await GetServicosAPI(grids.limit, grids.offset, grids.fNome, grids.fid_sis_status);
    response.refresh = 'concluido';
    response.onClickModal = this.clickChildCadastro;
    response.callBackPaginacao = this.callBackPaginacao;

    let nav = store.getState().servicos.grids.nav;
    nav.onClick[0] = this.clickChildListaAba;
    nav.onClick[1] = null;

    response.nav = nav;
    response.type = 'SERVICOS.TOOGLE_LISTA';

    this.updateRedux(response);
    grids = store.getState().servicos.grids;
    this.setState(grids);

  }



  render() {

    return (

      <div className="container">
        <div className="row">
          <h2 className="section-title">Serviços</h2>
          <div className="card">
            {this.navMenu(store.getState().servicos.grids.nav)}
            <div id="lista" className="dataTables_wrapper no-footer row">
              <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">

                {<FormEdit id='fNome'
                  onChange={this.handleInputChange}
                  label='Busque por nome'
                  value={this.state.fNome}
                  styleDiv='4' />}

                {<FormEdit id='submit'
                  label='Pesquisar'
                  styleDiv='submit'
                  styleField='submit'
                  typeField='submit'
                  icon='pesquisa'
                />}

                {<FormEdit id='cadNovo'
                  label='Novo Cadastro'
                  styleDiv='submit'
                  onClick={this.novoCadastro}
                  styleField='submit'
                  typeField='button'
                  icon='adiciona'
                />}

              </form>

              {this.Grid(store.getState().servicos.grids)}

            </div>
            <div id="cadastro" className="dataTables_wrapper no-footer row">
              {<ServicosUpdate />}
            </div>
          </div>
        </div>
      </div>

    );

  }
}
export default (Servicos); 
